import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MiCuentaService {

  constructor(
    private http: HttpClient
  ) { }


  getCliente() {
    return this.http.get(`${environment.baseUrl}cuenta/get-cliente`);
  }
  getUsuario() {
    return this.http.get(`${environment.baseUrl}cuenta/get-usuario`);
  }

  getUsuarioPassUpdate(data) {
    return this.http.put(`${environment.baseUrl}cuenta/change-pass`, data);
  }
  getClienteUpdate(data) {
    return this.http.put(`${environment.baseUrl}cuenta/cliente-update`, data);
   }
}
